module.exports = __webpack_public_path__ + "static/media/Artboard_2-100-min.438ebf30.jpg";